import { useQuery } from '@tanstack/react-query';
import { fetchQuestions } from '@/api/survey';
import { useAuth } from '@/contexts/AuthContext';
import { EnhancedSurveyQuestion, mapApiQuestionToEnhanced } from '@/types/api/enhanced-survey';

export interface SurveyQuestion {
  id: number;
  question: string;
  categoryId: number;
  isNegative: boolean;
}

export function useSurveyQuestions(surveyId: number) {
  const { user } = useAuth();
  
  return useQuery<EnhancedSurveyQuestion[]>({
    queryKey: ['survey-questions', surveyId],
    queryFn: () => fetchQuestions(surveyId),
    enabled: !!surveyId && surveyId > 0, // Only fetch if we have a valid survey ID
    select: (data) => {
      // Frontend should not do variable interpolation - that's a backend concern
      return data.map(apiQuestion => {
        return mapApiQuestionToEnhanced(apiQuestion);
      });
    }
  });
}